export enum CLIENT_DASHBOARD_TABS {
  MY_SCHEDULE = "myScheduleTab",
  MY_EMPLOYEES = "myEmployeesTab",
  PROFILE = "myCleaningsProfileSoftTab",
  OPTIONS = "myCleaningsOptionsSoftTab",
  BOOKINGS_TO_VALIDATE = "bookingsToValidateTab",
}
